import FollowButton from './follow-button'
export type { FollowButtonProps } from './follow-button'
export default FollowButton
